/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CalendarProviderLoginDto { 
    email?: string;
    redirectUri: string;
    provider: CalendarProviderLoginDto.ProviderEnum;
}
export namespace CalendarProviderLoginDto {
    export type ProviderEnum = 'google' | 'office365' | 'icloud' | 'outlook';
    export const ProviderEnum = {
        Google: 'google' as ProviderEnum,
        Office365: 'office365' as ProviderEnum,
        Icloud: 'icloud' as ProviderEnum,
        Outlook: 'outlook' as ProviderEnum
    };
}


